import { axiosInstance } from "../common";

const ENDPOINT_CONVERSION_RATES = '/currency/conversion';

export const getConversionRates = () => axiosInstance.get(ENDPOINT_CONVERSION_RATES).then(({ data }) => data)